import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ContactsService {
  private emailSignal = signal('support@brightscrip.com');
  private phoneSignal = signal('815-853-1348');

  get email() {
    return this.emailSignal.asReadonly();
  }

  get phone() {
    return this.phoneSignal.asReadonly();
  }

  refresh() {
    // This method can be used to refresh the contact details if needed.
    // For now, it does nothing as the values are static.
  }
}
